import React from 'react';

import {
  useSelector,
} from 'react-redux';

import {
  getUiState,
} from 'web-selectors';

import * as S from './styled';

const mapState = state => getUiState('namespace')(state);

const NamespaceLogo = () => {
  const namespace = useSelector(mapState);
  return (
    <S.Link
      href={namespace.home_url}
      logoUrl={namespace.sign_in_sign_up_logo?.url}
    />
  );
};

export default NamespaceLogo;
